<template>
  <v-row justify="center">
    <v-dialog
      v-model="showDialog"
      persistent
      max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Nouvelle clé d'api</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <ValidationObserver
                ref="form"
                v-slot="{ valid, handleSubmit }">
                <v-col cols="12">
                  <validation-input
                    v-model="name"
                    rules="required|min:3"
                    label="Nom*" />
                </v-col>
              </ValidationObserver>
              <v-col
                cols="12"
                sm="6">
                <multiselect
                  v-model="account"
                  :options="companyList"
                  track-by="pk"
                  label="name"
                  :searchable="true"
                  :placeholder="''"
                  :show-labels="false"
                  :multiple="false"
                  :close-on-select="false">
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Sélectionnez un compte</span>
                </multiselect>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="hideModal">
            Annuler
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="submit">
            Valider
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  export default {
    name: 'ApiKeyModal',
    components: { Multiselect },
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      // compte présélectionné (création depuis la liste des utilisateurs)
      initialAccount: {
        type: Object,
        default: null
      }
    },
    data () {
      return {
        companyList: [],
        dialog: false,
        name: null,
        account: null
      }
    },
    watch: {
      showDialog: {
        immediate: true,
        handler (val) {
          if (val && this.initialAccount) this.account = this.initialAccount
        }
      }
    },
    created () {
      this.initWidget()
    },
    methods: {
      async initWidget () {
        this.fetchAccounts()
      },
      hideModal () {
        this.$emit('close')
      },
      async fetchAccounts () {
        let index = 1
        while (true) {
          let { data } = await this.$api.get('accounts', { page: index, per_page: 50 })
          const { items, page, pages } = data
          this.companyList = this.companyList.concat(items)
          if (page === pages) {
            break
          }
          index++
        }
      },
      async submit () {
        let success = await this.$refs.form.validate()
        if (!success) {
          return
        }
        const payload = {
          name: this.name,
          account: this.account.pk
        }
        this.$emit('submit', payload)
      }
    }
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>
